"use client";

import { useQuery } from "@tanstack/react-query";
import { publicFeatureFlagQueryOptions } from "@/lib/feature-flags.functions";
import type { FeatureFlagKey } from "@/lib/feature-flags.keys";

/**
 * Ticket AD1a: fragt genau ein Flag über den engen Weg ab. Es wird keine Liste
 * mehr geladen, und eine Abweisung wird wie „aus" behandelt.
 */
export function useFeatureFlag(key: FeatureFlagKey): {
  enabled: boolean;
  loading: boolean;
} {
  const { data, isLoading } = useQuery(publicFeatureFlagQueryOptions(key));
  return { enabled: data?.enabled ?? false, loading: isLoading };
}
